export class LoginRequest {
    Username: string = "";
    Password: string = "";

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}